import { render, staticRenderFns } from "./portfolio-info.vue?vue&type=template&id=323b1a61&scoped=true&"
import script from "./portfolio-info.ts?vue&type=script&lang=ts&"
export * from "./portfolio-info.ts?vue&type=script&lang=ts&"
import style0 from "./portfolio-info.scss?vue&type=style&index=0&id=323b1a61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b1a61",
  null
  
)

export default component.exports